import { Tooltip } from 'antd'
import { isEmpty } from 'lodash'
import type { Dayjs } from 'dayjs'
import { Chart } from 'src/components/Chart'
import { ChartLineColors, ChartTitle, ChartUnit } from 'src/meta'
import type { ChartPt, Station } from 'src/models'
import type { MapLayer } from 'src/meta'
import { config } from 'src/config'
import { trailingTenMinuteMean } from '../station-dashboard/windChart'
import Styles from './ChartPanel.module.scss'

type ChartPanelProps = {
  selectedStation?: Station | null
  selectedLayer?: MapLayer | string
  chartData: ChartPt[]
  selectedTime?: Dayjs
  chartZoom?: { x: number; scale: number }
  onSelectDevice: (deviceId?: string) => void
  onOpenDashboard: () => void
  onMove: (x?: number) => void
}

export const ChartPanel = ({
  selectedStation,
  selectedLayer,
  chartData,
  selectedTime,
  chartZoom,
  onSelectDevice,
  onOpenDashboard,
  onMove,
}: ChartPanelProps) => {
  if (!selectedStation || !selectedLayer || ['cloud'].includes(selectedLayer)) {
    return null
  }
  const displayData = config.enableCloudWindTransform && selectedLayer === 'wind'
    ? trailingTenMinuteMean(chartData)
    : chartData

  return (
    <div className={Styles.chartArea}>
      <div className={Styles.stationType}>
        {selectedStation.devices.some(({ device_id }) => device_id === '01') && (
          <Tooltip title={'Device type: 01'}>
            <div onClick={() => onSelectDevice('01')}>{'Basic'}</div>
          </Tooltip>
        )}

        {selectedStation.devices
          .filter(({ device_id }) => device_id !== '01')
          .map(device => (
            <Tooltip key={device.device_id} title={`Device type: ${device.device_id}`}>
              <div className={Styles.full} onClick={() => onSelectDevice(device.device_id)}>
                {`Full(${device.device_id})`}
              </div>
            </Tooltip>
          ))}
      </div>

      <div className={Styles.title}>
        <Tooltip title={selectedStation.id}>
          <div className={Styles.stationName} onClick={onOpenDashboard}>
            {selectedStation.name}
          </div>
        </Tooltip>
        <div className={Styles.element}>{ChartTitle[selectedLayer as MapLayer]}</div>
      </div>

      {!isEmpty(chartData) ? (
        <Chart
          className={Styles.chart}
          data={displayData}
          current={selectedTime}
          minY={selectedLayer === 'wind' ? 0 : undefined}
          yAxisUnit={ChartUnit[selectedLayer as MapLayer] ?? ''}
          syncId={'chart'}
          lineColor={ChartLineColors[selectedLayer as MapLayer] ?? '#f03080'}
          zoom={chartZoom}
          xTickStepMinutes={selectedLayer === 'wind' ? 5 : undefined}
          onMove={onMove}
          noMinor
        />
      ) : (
        <div className={Styles.noData}>{'No data available'}</div>
      )}
    </div>
  )
}
